import btcIcon from '@/assets/icons/currencies/btc.svg'
import usdcIcon from '@/assets/icons/currencies/usdc.svg'
import usdtIcon from '@/assets/icons/currencies/usdt.svg'

export function getCurrencySymbol(currencyCode) {
    const currencySymbols = {
        'USD': '\u0024', // $
        'EUR': '\u20AC', // €
        'RUB': '\u20BD', // ₽
        'JPY': '\u00A5', // ¥
        'GBP': '\u00A3', // £
        'USDC': '$',
        'USDT': '₮',
        'BTC': '₿'
    };

    if (currencyCode) {
        return currencySymbols[currencyCode.toUpperCase()] || '\u00A4';  // or ¤
    } else {
        return '';
    }
}

export function getCurrencyIcon(currencyCode) {
    const currencyIcons = {
        'BTC': btcIcon,
        'USDC': usdcIcon,
        'USDT': usdtIcon,
    };

    if (currencyCode) {
        return currencyIcons[currencyCode.toUpperCase()] || '';
    } else {
        return '';
    }
}
